import lodash from 'lodash';
import React from 'react';
import {Link} from 'react-router-dom';
import {PageTitle} from '../../common/pageTitle/PageTitle';

import {contactRoute} from '../../routePaths';
import {Helmet} from 'react-helmet';
import './supportingCompaniesPage.scss';

import joinImage1 from './assets/nei-join1.jpg';
import joinImage2 from './assets/nei-join2.jpg';

/**
 * The SupportingCompaniesPage component.
 *
 * @constructor
 */
export class SupportingCompaniesPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Gets the element for a benefit item.
   *
   * @param {string} benefitText
   * @returns {{}}
   */
  getBenefitItem = (benefitText) => {
    return (
      <div className="benefit-item">
        <div className="benefit-item-icon">
          <div className="icon-circle-outer">
            <div className="icon-circle-inner">
              <i className="icon-circle fa fa-check" aria-hidden="true" />
            </div>
          </div>
        </div>
        <div className="benefit-item-label">{benefitText}</div>
      </div>
    );
  };

  /**
   * Gets the column lists of companies.
   *
   * @param {Array.<{}>} companies
   * @param {number} columns
   * @returns {Array.<Array.<{}>>}
   */
  getCompanyColumns = (companies, columns) => {
    if (!companies || !companies.length || !Array.isArray(companies)) {
      return [];
    }

    const columnCount = parseInt(columns, 10) || 2;
    const totalCount = companies.length;

    let countPerColumn = Math.floor(totalCount / columnCount);
    if (totalCount - (countPerColumn * columnCount)) {
      countPerColumn += 1;
    }

    return lodash.chunk(companies, countPerColumn);
  };

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const companyColumns = this.getCompanyColumns([
      {"name":"Air Products and Chemicals"},
      {"name":"Adelphia Gateway, LLC"},
      {"name":"Alliant Energy Corporation"},
      {"name":"American Midstream"},
     // {"name":"AmeriGas (LPG)"},
      {"name":"Atlanta Gas Light"},
      {"name":"Atmos Energy Corporation"},
      {"name":"Azure Midstream"},
      {"name":"Basalt"},
      {"name":"Bay City Gas Co."},
      {"name":"Badger Daylighting"},
      {"name":"Black Bear"},
      {"name":"Blackburn Manufacturing"},
      //{"name":"Bluestone"},
      //{"name":"BP Pipelines"},
      //{"name":"Breiburn "},
      {"name":"Buckeye Partners, L.P."},
      {"name":"Chattanooga Gas"},
      {"name":"Cenex Pipeline LLC"},
      {"name":"CHS MRI Inc"},
      //{"name":"Citizens Gas Fuel Co"},
      //{"name":"City of Monroe, NC"},
      //{"name":"City of Rochester, MN"},
      //{"name":"Consumers Energy"},
      {"name":"Crestwood Midstream Partners"},
      //{"name":"Distribution Contractors Association"},
      //{"name":"DCP Midstream Partners, LP"},
      {"name":"Dominion Energy Ohio"},
      //{"name":"DTE Gas"},
      {"name":"Enable Midstream Partners"},
      {"name":"Enbridge Energy"},
      //{"name":"Enlink Midstream Partners, LP"},
      {"name":"EOG Resources, Inc."},
      {"name":"Front Range LLC"},
      // {"name":"Georgia Pacific"},
      {"name":"Hallen Construction"},
      {"name":"Hawthorne"},
      //{"name":"Idaho Division of Building Services"},
      {"name":"Intermountain Gas"},
      {"name":"Interstate Energy Company"},
      //{"name":"Iowa Pipeline Association"},
      {"name":"Iowa 811"},
      {"name":"IRTH"},
      {"name":"Jayhawk Pipeline LLC."},
      {"name":"Kinder Morgan, Inc."},
      {"name":"Legacy Reserves"},
      {"name":"Lyondell Basell"},
      {"name":"Magellan Midstream"},
      //{"name":"Marathon Pipe Line"},
      //{"name":"Marysville Hydrocarbons LLC"},
      //{"name":"Merit Energy Company"},
      //{"name":"Michigan Gas Utilities"},
      {"name":"Miller Pipeline"},
      //{"name":"Minnesota Office of Pipeline Safety"},
      //{"name":"Minnesota Utility Contractors Association"},
      //{"name":"MISSDIG811"},
     // {"name":"Miss Utility of Maryland"},
      {"name":"M3 Midstream LLC (Momentum)"},
      {"name":"Nebraska 811"},
      {"name":"Nextera"},
      //{"name":"Northern Natural Gas"},
      {"name":"Nicor Gas"},
      {"name":"NuStar Energy, L.P."},
      //{"name":"NTU"},
      {"name":"ONEOK"},
      {"name":"Oregon 811"},
      //{"name":"Omnimex/Basin Pipeline"},
      //{"name":"Oneok"},
      // {"name":"Panhandle Eastern Pipeline Co."},
      {"name":"Patriot Pipeline Safety"},
      {"name":"PA American Water"},
      {"name":"Pecan Pipeline"},
      {"name":"PECO Energy"},
      {"name":"Pennsylvania 811"},
      {"name":"Pennsylvania Utility Contractors Association"},
      {"name":"Peoples Gas"},
      {"name":"Pinnacle Resources"},
      {"name":"Pipeline Technology"},
      {"name":"Planet Underground"},
      //{"name":"Plains All American Pipeline"},
      {"name":"PPL"},
      {"name":"PSC/ ARB"},
      {"name":"San Diego Gas & Electric"},
      //{"name":"SEMCO"},
      // {"name":"SEMGroup Corporation"},
      {"name":"SoCal Gas"},
      {"name":"Southcross Energy"},
      {"name":"Southerland & Associates"},
      {"name":"South Dakota Public Utility Commission"},
      {"name":"Southern Cross"},
      {"name": "Southern Company Gas"},
      // {"name":"Sunoco"},
      {"name":"Stagecoach"},
      {"name":"Texas811"},
      {"name":"Texas Water Infrastructure Network"},
      {"name":"Third Coast Midstream"},
      //{"name":"TransCanada"},
      //{"name":"UGI Utilities, Inc."},
      {"name":"UGIES"},
      {"name":"UGI Utilities Inc."},
      {"name":"Vac-tron (VermeerMVS)"},
      {"name":"Virginia Natural Gas"},
      //{"name":"Washington Gas"},
      {"name":"Williams"},
    //{"name":"Wisconsin Public Service"},
    //{"name":"Wolverine Pipe Line Co."},
      {"name":"WSB & Associates, Inc."},
      {"name":"Xcel Energy Inc."}

  ], 2);

    return (
      <div id="supporting-companies-page" className="system-page">
        <Helmet>
          <title>Supporting Companies and Partners - NEI</title>
          <meta name = "description" content ="The National Excavator Initiative thanks the following companies and organizations for their generosity and support of this effort." />
        </Helmet>
        <div className="container">
          <div className="row">
            <p className="col-sm">
              The National Excavator Initiative thanks the following companies and organizations for their generosity and support of this effort.
            </p>
          </div>
          <div className="row">
            {companyColumns.map((companies, columnIndex) => {
              return (
                <ul className="col-sm" key={columnIndex}>
                  {companies.map((company, companyIndex) => {
                    return (
                      <li key={companyIndex}>
                        <span>{company.name}</span>
                      </li>
                    );
                  })}
                </ul>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

SupportingCompaniesPage.propTypes = {};

export default SupportingCompaniesPage;



// WEBPACK FOOTER //
// ./src/components/pages/supportingCompanies/SupportingCompaniesPage.js